import EntranceLoginForm from './EntranceLoginForm';

export default function EntranceLoginPage() {
  return <EntranceLoginForm />;
}

